// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"43d8b2d6","355":"1fd05948"}[chunkId] + ".chunk.js";
};